export default __webpack_public_path__ + "static/media/step_A_EN.28eccac4.png";